import * as React from 'react';

export function Clearfix () {
    return (
      <div className='clearfix' />
    );
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/uiComponents/layout/Clearfix.tsx